module.exports = __webpack_public_path__ + "static/media/money-check-edit-alt.3709c2d9.svg";